import { Form, Formik, Field, ErrorMessage } from "formik";
import { mobileValidation } from "@/utils/valitation/auth";
import Image from "@/components/global/Image";
import { getCookie, setCookie } from "cookies-next";
import Loading from "@/components/global/Loading";
import { logInByMobile } from "@/services/auth";
import toast from "react-hot-toast";
import { preventLettersInInput } from "@/utils/global";
import { useRouter } from "next/router";

const LoginMobile = ({ t, Context }) => {
  const { locale } = useRouter();
  const handleMobileLogin = async ({ phone_number }, { setSubmitting }) => {
    const handshake = getCookie("handshake");
    const res = await logInByMobile(handshake, `00966${phone_number}`);
    if (res?.status === 200) {
      toast.success(
        locale === "en" ? "You logged in successfully" : "تم تسجيل الدخول بنجاح"
      );
      Context?.dispatch({ type: "auth" });
      Context?.dispatch({ type: "verifyOtpLoginMobile" });
      setCookie("phone_number", `00966${phone_number}`, {
        maxAge: 60 * 60 * 24 * 10,
      });
      setSubmitting(false);
      return;
    }

    let error_message;
    switch (res?.error?.error) {
      case "This mobile number is not registered.": {
        error_message = locale === "en" ? "This mobile number is not registered." : "هذا الرقم الذي ادخلته غير مسجل";
        break;
      }
      default: {
        error_message = locale === "en" ? "Error Occured, please try again" : "حدث خطأ, برجاء المحاولة مره أخرى";
        break;
      }
    }
    toast.error(error_message);
    setSubmitting(false);
  };
  return (
    <Formik
      onSubmit={handleMobileLogin}
      initialValues={{ phone_number: "" }}
      validationSchema={mobileValidation(t)}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className="mb-3 col-span-full sm:col-span-1">
            <div
              dir="ltr"
              className="flex items-center gap-1 border rounded-sm"
            >
              <Image
                loading="eager"
                className="mx-2 rounded-sm"
                src="/imgs/KSA.svg"
                height={30}
                width={30}
                alt="KSA Img !"
              />
              <span className="text-zinc-500 mx-1.5 max-sm:text-sm">+966</span>
              <Field
                name="phone_number"
                type="tel"
                onKeyDown={(event) => {
                  preventLettersInInput(event);
                }}
                id="phone_number"
                placeholder="5xxxxxxxx"
                maxLength={9}
                className="outline-none border-none p-1.5 max-sm:placeholder:text-sm max-sm:text-sm flex-1"
              />
            </div>
            <ErrorMessage
              name="phone_number"
              component="p"
              className="text-sm text-warning"
            />
          </div>
          <div
            dir="ltr"
            className="flex items-center justify-between my-3 max-sm:text-sm"
          >
            <div
              onClick={() => {
                Context?.dispatch({ type: "auth" });
                Context?.dispatch({ type: "forgot" });
              }}
              className="font-bold underline cursor-pointer"
            >
              {t("Forgot Password")}
            </div>
          </div>
          <button
            className="bg-primary text-white p-1.5 max-sm:text-sm rounded-md w-full font-semibold"
            type="submit"
          >
            {isSubmitting ? <Loading /> : t("Request OTP")}
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default LoginMobile;
